import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const Production = () => import('@/views/Production')
const ThreeNav = () => import('@/views/ThreeNav')
const FourNav = () => import('@/views/FourNav')
const FiveNav = () => import('@/views/FiveNav')
const SixNav = () => import('@/views/SixNav')
const SevenNav = () => import('@/views/SevenNav')
const EightNav = () => import('@/views/EightNav')
const NineNav = () => import('@/views/NineNav')
const TenNav = () => import('@/views/TenNav')
const ElevenNav = () => import('@/views/ElevenNav')
const TwelveNav = () => import('@/views/TwelveNav')
const LowCarbonCategory = () => import('@/views/ourService-1-Nav')
const EnergyCategory = () => import('@/views/ourService-2-Nav')
const GreenBuildingCategory = () => import('@/views/ourService-3-Nav')
const ComplianceProductionCategory = () => import('@/views/ourService-4-Nav')
const TraceabilityManagementCategory = () => import('@/views/ourService-5-Nav')
const SocialResponsibilityCategory = () => import('@/views/ourService-6-Nav')
const HealthAndSafetyCategory = () => import('@/views/ourService-7-Nav')
const ComplianceRiskCategory = () => import('@/views/ourService-8-Nav')
const CapacityBuildingCategory = () => import('@/views/ourService-9-Nav')

const Demo = () => import('@/views/Demo')
const ProductionBrain = () => import('@/components/production/ProductionBrain.vue')
const YunZhaoShang = () => import('@/components/yun_zhaoshang/index.vue')
const redcPlus = () => import('@/components/redc-plus/index.vue')
const esg = () => import('@/components/esg/index.vue')
const ecoVadis = () => import('@/components/eco-vadis/index.vue')
const ccer = () => import('@/components/ccer/index.vue')
const lca = () => import('@/components/lca/index.vue')
const Shopping = () => import('@/views/Shopping')

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:Home
  },
  {
    path:'/production',
    component:Production,
    children:[
      {
        path:'productCarbon',
        component:ProductionBrain
      },
      {
        path:'tissueCarbon',
        component:YunZhaoShang
      },
      {
        path:'redcPlus',
        component:redcPlus
      },
      {
        path:'esg',
        component:esg
      },
      {
        path:'ecoVadis',
        component:ecoVadis
      },
    ]
  },
  {
    path: '/joinUs',  // 独立出来
    component: EightNav
  },
  {
    path:'/SustainableSupplyChainCloud',
    component:ThreeNav
  },
  {
    path:'/toolCloud',
    component:FourNav,
  },
  {
    path:'/aboutUs',
    component:FiveNav,
  },
  {
    path:'/newsCenter',
    component:SixNav,
  },
  {
    path:'/aiSearch',
    component:SevenNav,
  },
  {
    path:'/trial',
    component:Demo
  },
  {
    path:'/shopping',
    component:Shopping
  },
  {
    path: '/training', 
    component: NineNav
  },
  {
    path:'/cbam',
    component: TenNav
  },
  {
    path:'/SupplyChainAudit',
    component: ElevenNav
  },
  {
    path:'/ESG-evaluation',
    component: TwelveNav
  },
  {
    path:'/lowCarbonCategory',
    component: LowCarbonCategory
  },
  {
    path:'/energyCategory',
    component: EnergyCategory
  },
  {
    path:'/greenBuildingCategory',
    component: GreenBuildingCategory
  },
  {
    path:'/complianceProductionCategory',
    component: ComplianceProductionCategory
  },
  {
    path:'/traceabilityManagementCategory',
    component: TraceabilityManagementCategory
  },
  {
    path:'/socialResponsibilityCategory',
    component: SocialResponsibilityCategory
  },
  {
    path:'/healthAndSafetyCategory',
    component: HealthAndSafetyCategory
  },
  {
    path:'/complianceRiskCategory',
    component: ComplianceRiskCategory
  },
  {
    path:'/capacityBuildingCategory',
    component: CapacityBuildingCategory
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router